/* hs-eslint ignored failing-rules */

import { useCallback, useEffect, useRef } from 'react';
import { cancelRequest } from './API';
import { invalidateRequestInCache } from './request-cache';
import { AsyncQueryStatus } from '../../../constants/snowflakeQuery';
// note: auto canceling support both report and dataset async query ids

export const useAutoCancel = definitionWithOptions => {
  // keep track of the latest report or dataset
  const definitionWithOptionsRef = useRef(definitionWithOptions);
  useEffect(() => {
    definitionWithOptionsRef.current = definitionWithOptions;
  }, [definitionWithOptions]);

  // clear the ref on unmount (cancels on unmount) and remove cached request
  useEffect(() => {
    return () => {
      if (definitionWithOptionsRef.current) {
        invalidateRequestInCache(definitionWithOptionsRef.current);
        definitionWithOptionsRef.current = undefined;
      }
    };
  }, []);

  // this callback should be passed to the 'onTick' handler of resolve
  return useCallback((response, reportDefinition) => {
    const queryId = response.getIn(['asyncQueryResponseMeta', 'queryId']);
    const status = response.getIn(['asyncQueryResponseMeta', 'queryStatus']);

    // if the query is already complete, there is no need to cancel
    if (status !== AsyncQueryStatus.RUNNING) {
      return false;
    }

    // check if the component has unmounted, or if the query from
    // this tick is out-of-date
    if (definitionWithOptionsRef.current !== undefined && !reportDefinition.equals(definitionWithOptionsRef.current) && queryId) {
      cancelRequest(queryId).catch(error => {
        console.error(`Error in resolve-utils, could not automatically cancel query ${queryId}`, error);
      });
      return true;
    }
    return false;
  }, []);
};